import { Editable, EditableInput, EditablePreview } from '@chakra-ui/react';
import { color } from '@ifixit/primitives';
import { useEffect, useState } from 'react';

interface EditableCellProps {
   cellProps: any;
   onSubmit: any;
   isDisabled?: boolean;
   datalistOptions?: Array<string>;
}

export const EditableCell = ({
   cellProps,
   onSubmit,
   isDisabled = false,
   datalistOptions = [],
}: EditableCellProps) => {
   const initialValue = cellProps.getValue() || cellProps.column.columnDef.header;
   const [value, setValue] = useState(initialValue);
   useEffect(() => setValue(initialValue), [initialValue]);
   return (
      <>
         <Editable
            value={value}
            onChange={setValue}
            onSubmit={onSubmit}
            isDisabled={isDisabled}
            h="28px"
         >
            <EditablePreview
               w="100%"
               h="100%"
               color={cellProps.getValue() ? 'inherit' : color.gray[400]}
               overflow="hidden"
               textOverflow="ellipsis"
            />
            <EditableInput
               list={datalistOptions.length ? cellProps.cell.id + '-list' : undefined}
            />
         </Editable>
         {datalistOptions.length ? (
            <datalist id={cellProps.cell.id + '-list'}>
               {datalistOptions.map(option => (
                  <option key={option} value={option} />
               ))}
            </datalist>
         ) : null}
      </>
   );
};
